/**
 * Client-Side Profile API
 *
 * `directApiClient`-backed helpers for profile mutations migrated in LF-3217.
 *
 * Most profile mutations remain server actions because they need to bust the
 * `unstable_cache` keyed by access token (used by Server Components in
 * `(dashboard)` layout) — see `./CLAUDE.md`. `submitSuggestion` is the
 * exception: it has no cache to bust and is well-suited to a plain client
 * mutation.
 */

import { directApiClient } from '@/lib/api/direct-client';
import {
  SubmitSuggestionRequest,
  SubmitSuggestionResponse,
  SubmitSuggestionSchema
} from './types';

export class ProfileValidationError extends Error {
  constructor(
    message: string,
    public readonly validationErrors?: Record<string, string[] | undefined>
  ) {
    super(message);
    this.name = 'ProfileValidationError';
  }
}

/**
 * Submit a product suggestion
 */
export async function submitSuggestion(
  data: SubmitSuggestionRequest
): Promise<SubmitSuggestionResponse> {
  const validation = SubmitSuggestionSchema.safeParse(data);
  if (!validation.success) {
    throw new ProfileValidationError(
      'Validation failed',
      validation.error.flatten().fieldErrors
    );
  }

  return directApiClient.post<SubmitSuggestionResponse>(
    '/profile/submit-suggestion',
    validation.data
  );
}

export const profileApi = {
  submitSuggestion
};
